import _ from 'lodash'

// Pure comparisons of the zones a map shows, without Leaflet so they can be unit tested. The callers build their
// layers in render (a new array every time), so the maps compare by content to know whether anything really changed.

/** A zone on a map: its area and the colour it is drawn in */
export interface ZoneLayer {
    geoJSON?: object | null
    color?: string
}

/** The same object, or one with the same content (a zone reloaded from the server) */
const sameContent = (a: unknown, b: unknown) => a === b || _.isEqual(a, b)

/** Whether both lists draw the same areas in the same order, whatever their colours */
export function sameZoneShapes(a: ZoneLayer[] = [], b: ZoneLayer[] = []) {
    const shapesA = a.filter((zone) => zone.geoJSON)
    const shapesB = b.filter((zone) => zone.geoJSON)

    return shapesA.length === shapesB.length && shapesA.every((zone, index) => sameContent(zone.geoJSON, shapesB[index].geoJSON))
}

/** Whether both lists draw the same areas in the same colours */
export function sameZoneLayers(a: ZoneLayer[] = [], b: ZoneLayer[] = []) {
    const shapesA = a.filter((zone) => zone.geoJSON)
    const shapesB = b.filter((zone) => zone.geoJSON)

    return sameZoneShapes(a, b) && shapesA.every((zone, index) => zone.color === shapesB[index].color)
}
